export interface RateCalculation {
    id: number;
    name: string;
    description: string;
    is_percentage: boolean;
}
